import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "reset"]

  connect() {
    if (this.hasResetTarget) {
      this._savedContent = this.resetTarget.innerHTML
    }
  }

  open() {
    this.modalTarget.showModal()
  }

  close() {
    // Works both when the controller wraps a trigger+dialog (modal target)
    // and when the controller sits directly on the <dialog> element itself.
    const modal = this.hasModalTarget ? this.modalTarget : this.element
    modal.close()
    if (this.hasResetTarget && this._savedContent) {
      this.resetTarget.innerHTML = this._savedContent
    }
  }
}
